export default __webpack_public_path__ + "static/media/guide16.3040cdd0.png";